export const getExtension = (str) => {
  return /(?:\.([^.]+))?$/.exec(str)[1] || null
}
